import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getRestEndpoint } from 'src/app/helpers/api-url';

import {
  IBillingType,
  IProviderAPI,
} from '../../interfaces/provider/provider.interfaces';

@Injectable({
  providedIn: 'root',
})
export class ProviderService {
  constructor(private http: HttpClient) {}

  createProvider(provider: IProviderAPI): Observable<IProviderAPI> {
    return this.http.post<IProviderAPI>(
      `${getRestEndpoint()}/providers`,
      provider,
    );
  }

  editProvider(provider: IProviderAPI): Observable<IProviderAPI> {
    return this.http.put<IProviderAPI>(
      `${getRestEndpoint()}/providers/${provider.id}`,
      provider,
    );
  }

  addBillingType(billing: IBillingType): Observable<IBillingType> {
    return this.http.post<IBillingType>(
      `${getRestEndpoint()}/billingids`,
      billing,
    );
  }

  editBillingType(
    billing: IBillingType,
    rowId: number,
  ): Observable<IBillingType> {
    return this.http.put<IBillingType>(
      `${getRestEndpoint()}/billingids/${rowId}`,
      billing,
    );
  }
}
